import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/img/home_title.png'
import _imports_1 from '../assets/img/home_sub_title.png'
import _imports_2 from '../assets/img/result_title.png'
import _imports_3 from '../assets/img/result_msg_btn.png'
import _imports_4 from '../assets/img/result_again_btn.png'
import _imports_5 from '../assets/img/result_share_btn.png'
import _imports_6 from '../assets/img/result_submit_btn.png'
import _imports_7 from '../assets/img/result_close_btn.png'


const _hoisted_1 = { class: "page-result" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "result-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "title",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "sub-title",
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_3 = { class: "result-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "result-btns" }
const _hoisted_6 = {
  key: 0,
  class: "message-dialog"
}
const _hoisted_7 = { class: "message-dialog-inner" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", null, "2022年你最关心的是什么？封面新闻帮你捎话上两会！", -1)
const _hoisted_9 = { class: "message-dialog-btns" }
const _hoisted_10 = {
  key: 1,
  class: "poster-wrap"
}
const _hoisted_11 = { class: "poster-inner" }
const _hoisted_12 = { class: "poster-img" }
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "长按图片保存到手机", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", null, _toDisplayString(_ctx.correctTotal), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("img", {
        class: "msg-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.msgDialogShow = true)),
        src: _imports_3,
        alt: ""
      }),
      _createElementVNode("img", {
        class: "again-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.again && _ctx.again(...args))),
        src: _imports_4,
        alt: ""
      }),
      _createElementVNode("img", {
        class: "share-btn",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.share && _ctx.share(...args))),
        src: _imports_5,
        alt: ""
      })
    ]),
    (_ctx.msgDialogShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.message) = $event)),
              maxlength: "200",
              placeholder: "200字以内"
            }, null, 512), [
              [_vModelText, _ctx.message]
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                class: "submit-btn",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
                src: _imports_6,
                alt: ""
              }),
              _createElementVNode("img", {
                class: "close-btn",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.msgDialogShow = false)),
                src: _imports_7,
                alt: ""
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.posterShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              class: "poster-close",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.posterShow = false)),
              src: "https://yunyingcdn.thecover.cn/o_1e054uo2g1ctb14uqkv0mit4blp.png",
              alt: ""
            }),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("img", {
                src: _ctx.imgUrl,
                alt: ""
              }, null, 8, _hoisted_13)
            ]),
            _hoisted_14
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}